import { defineKeyframes } from '@pandacss/dev';

import { css } from '@headout/pixie/css';

const snowfallLarge = {
	'0%': {
		transform: 'translateY(-1rem) rotate(0deg)',
	},
	'100%': {
		transform: 'translateY(24rem) rotate(360deg)',
	},
};
const snowfallMedium = {
	'0%': {
		transform: 'translateY(-1rem) translateX(-10px) rotate(0deg)',
	},
	'50%': {
		transform: 'translateY(12rem) translateX(20px) rotate(180deg)',
	},
	'100%': {
		transform: 'translateY(24rem) translateX(-10px) rotate(360deg)',
	},
};
const snowfallSmall = {
	'0%': {
		transform: 'translateY(-1rem) translateX(0) rotate(0deg)',
	},
	'25%': {
		transform: 'translateY(6rem) translateX(20px) rotate(90deg)',
	},
	'75%': {
		transform: 'translateY(18rem) translateX(-10px) rotate(270deg)',
	},
	'100%': {
		transform: 'translateY(24rem) translateX(0) rotate(360deg)',
	},
};

export const snowflakeKeyframes = defineKeyframes({
	snowfallLarge,
	snowfallMedium,
	snowfallSmall,
});

export const snowflakeStyles = css({
	zIndex: '1',
	display: 'inline-block',
	position: 'absolute',
	color: 'core.primary.white',
	top: '-10px',
	pointerEvents: 'none',
	fontWeight: 'font.weight.700',

	// Sizes
	'&:nth-child(3n)': {
		fontSize: 'font.size.24',
		animation: 'snowfallLarge 8s linear infinite',
	},
	'&:nth-child(3n + 1)': {
		fontSize: 'font.size.20',
		animation: 'snowfallMedium 6s linear infinite',
	},
	'&:nth-child(3n + 2)': {
		fontSize: 'font.size.18',
		animation: 'snowfallSmall 4s linear infinite',
	},

	// Positions
	'&:nth-child(7n)': {
		left: '10%',
		animationDelay: '0s',
	},
	'&:nth-child(7n + 1)': {
		left: '25%',
		animationDelay: '1s',
	},
	'&:nth-child(7n + 2)': {
		left: '40%',
		animationDelay: '1.5s',
	},
	'&:nth-child(7n + 3)': {
		left: '55%',
		animationDelay: '2s',
	},
	'&:nth-child(7n + 4)': {
		left: '70%',
		animationDelay: '2.5s',
	},
	'&:nth-child(7n + 5)': {
		left: '85%',
		animationDelay: '3s',
	},
	'&:nth-child(7n + 6)': {
		left: '95%',
		animationDelay: '3.5s',
	},

	// Opacities
	'&:nth-child(5n)': {
		opacity: 1,
	},
	'&:nth-child(5n + 1)': {
		opacity: 0.9,
	},
	'&:nth-child(5n + 2)': {
		opacity: 0.8,
	},
	'&:nth-child(5n + 3)': {
		opacity: 0.7,
	},
	'&:nth-child(5n + 4)': {
		opacity: 0.6,
	},
});
